import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { DropdownControl } from "../control/dropdown-control";
// import { Select, Tooltip } from "@h3/antd-vue";
import { Select, Tooltip } from "@h3/antd-vue";
let dropdownMulti = class dropdownMulti extends DropdownControl {
    // testVal:any
    onChange(val) {
        this.hasSelectBatchImport = false;
        if (val && val.length > 0) {
            this.setValue(Array.isArray(val) ? val.slice() : val);
        }
        else {
            this.ctrl.value = null;
        }
        this.val = val;
        if (!this.multiple) {
            return;
        }
        super.resetDisableds();
    }
    getOPt() {
        super.getOptions();
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
    destroyed() {
        super.destroyed();
    }
};
dropdownMulti = tslib_1.__decorate([
    Component({
        name: "dropdownMulti",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
        },
    })
], dropdownMulti);
export default dropdownMulti;
